import moment from 'moment-timezone';
import qs from 'qs';
import {
  CANCELLATION_REASONS_FAILURE,
  CANCELLATION_REASONS_REQUEST,
  CANCELLATION_REASONS_SUCCESS,
} from '../constants/actions';
import config from '../../config';
import { getItem, setItem } from '../utils/storage';
import { fetchM } from './fetchM';
import { handleError } from './error';

function cancellationReasonsRequest() {
  return {
    type: CANCELLATION_REASONS_REQUEST,
  };
}

function cancellationReasonsSuccess(data, token = null) {
  return {
    type: CANCELLATION_REASONS_SUCCESS,
    payload: {
      data,
      token,
    },
  };
}

function cancellationReasonsError(message) {
  return {
    type: CANCELLATION_REASONS_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchCancellationReasons(fresh = true) {
  return (dispatch) => {
    let token = null;
    let reload = false;
    dispatch(cancellationReasonsRequest());
    if (!fresh) {
      let cancellationReasonsData = {};
      try {
        cancellationReasonsData = JSON.parse(getItem(`${config.get('appName')}.cancellationReasons`)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !cancellationReasonsData.data ||
        config.get('version') !== cancellationReasonsData.version ||
        moment().isAfter(moment(cancellationReasonsData.createdAt).add(1, 'day'))
      ) {
        reload = true;
      }
      if (!reload) {
        dispatch(cancellationReasonsSuccess(cancellationReasonsData.data));
        return Promise.resolve();
      }
    }
    const q = Object.assign({
      limit: 0,
    });
    return dispatch(fetchM(`/cancellation_reasons/?${qs.stringify(q)}`, {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((data) => {
        try {
          setItem(`${config.get('appName')}.cancellationReasons`, JSON.stringify({
            data,
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(cancellationReasonsSuccess(data, token));
      })
      .catch(err => dispatch(handleError(err, cancellationReasonsError)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/cancellationReasons.js